import axios from "axios";
import {
  CREATE_SUBTOPIC_DONE,
  CREATE_SUBTOPIC_ERROR,
  CREATE_SUBTOPIC_URL,
  DELETE_SUBTOPIC_URL,
  GET_SUBTOPIC_DONE,
  GET_SUBTOPIC_ERROR,
  GET_SUBTOPIC_URL,
  UPDATE_SUBTOPIC_URL,
  ORDER_SUBTOPIC_URL,
} from ".";
import { REQUEST_FAILED } from "../global/type";
import { getCookie } from "../../../config/cookie";
import { showToastMsg } from "../global/action";

const authHeaders = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getCookie("token")}`,
  },
});

export const getAllSubtopicsForGroup = (groupId, abortSignal) => {
  return async (dispatch) => {
    try {
      const requestOptions = { ...authHeaders() };
      if (abortSignal) requestOptions.signal = abortSignal;
      const response = await axios.post(GET_SUBTOPIC_URL, { group_id: groupId }, requestOptions);
      if (response.status === 200) {
        dispatch({ type: GET_SUBTOPIC_DONE, payload: response?.data?.data });
        return response?.data?.data;
      } else {
        dispatch({ type: GET_SUBTOPIC_ERROR });
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        dispatch({ type: REQUEST_FAILED, payload: error?.response });
      }
    }
  };
};

export const createSubtopic = (formdata) => {
  return (dispatch) => {
    return axios
      .post(CREATE_SUBTOPIC_URL, formdata, authHeaders())
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: CREATE_SUBTOPIC_DONE });
          dispatch(showToastMsg(res?.data?.message));
          return res?.data;
        } else {
          dispatch(showToastMsg(res?.data?.message));
          return res?.data;
        }
      })
      .catch((err) => {
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      });
  };
};

export const updateSubtopic = (subtopicData, subtopic_id) => {
  return (dispatch) => {
    return axios
      .put(`${UPDATE_SUBTOPIC_URL}/${subtopic_id}`, subtopicData, authHeaders())
      .then((res) => {
        return res?.data;
      })
      .catch((err) => {
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      });
  };
};

export const deleteSubtopic = (subtopic_id) => {
  return (dispatch) => {
    return axios
      .delete(`${DELETE_SUBTOPIC_URL}/${subtopic_id}`, authHeaders())
      .then((res) => {
        return res?.data;
      })
      .catch((err) => {
        dispatch({ type: REQUEST_FAILED, payload: err?.response });
      });
  };
};

export const reorderSubtopics = (body, topic_id) => async () => {
  try {
    const responseData = await axios.post(
      `${ORDER_SUBTOPIC_URL}/${topic_id}`,
      body,
      authHeaders(),
    );
    return responseData;
  } catch (error) {
    // silent
  }
};
